module.exports = {
	"fileName": "/contracts/Migrations.sol",
	"name": "Migrations",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "new_address",
					"type": "address"
				}
			],
			"name": "upgrade",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "last_completed_migration",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "completed",
					"type": "uint256"
				}
			],
			"name": "setCompleted",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"type": "constructor"
		}
	],
	"source": "pragma solidity ^0.4.2;\n\ncontract Migrations {\n  address public owner;\n  uint public last_completed_migration;\n\n  modifier restricted() {\n    if (msg.sender == owner) _;\n  }\n\n  function Migrations() {\n    owner = msg.sender;\n  }\n\n  function setCompleted(uint completed) restricted {\n    last_completed_migration = completed;\n  }\n\n  function upgrade(address new_address) restricted {\n    Migrations upgraded = Migrations(new_address);\n    upgraded.setCompleted(last_completed_migration);\n  }\n}\n",
	"abiDocs": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "new_address",
					"type": "address"
				}
			],
			"name": "upgrade",
			"outputs": [],
			"payable": false,
			"type": "function",
			"signature": "upgrade(address)",
			"signatureHash": "0900f010"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "last_completed_migration",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "last_completed_migration()",
			"signatureHash": "445df0ac"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "owner()",
			"signatureHash": "8da5cb5b"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "completed",
					"type": "uint256"
				}
			],
			"name": "setCompleted",
			"outputs": [],
			"payable": false,
			"type": "function",
			"signature": "setCompleted(uint256)",
			"signatureHash": "fdacd576"
		},
		{
			"inputs": [],
			"payable": false,
			"type": "constructor"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/Migrations.json
// module id = 1082
// module chunks = 0